// extracted by mini-css-extract-plugin
export var actionText = "_oy-4";
export var container = "_oy-0";
export var leftSection = "_oy-1";
export var rightSection = "_oy-2";
export var settingsButton = "_oy-6";
export var settingsIcon = "_oy-7";
export var shortcut = "_oy-5";
export var shortcutGroup = "_oy-3";